@if (!hasBindValue) {
  <!-- One listener that assigns `current` before emitting. `[(ngModel)]` plus a second (ngModelChange) puts two
       listeners on the same output and Angular fires them in declaration order — a trap this shared control must
       not carry, because every screen using <cqme-select> would inherit it (#267). -->
  <ng-select
    (ngModelChange)="current = $event; onCurrentChange($event)"
    [ngModel]="current"
    [bindLabel]="bindLabel"
    [clearable]="clearable"
    [disabled]="disabled"
    [items]="options"
    [multiple]="multiple"
    [placeholder]="placeholder"
    [searchFn]="defaultSearchFn"
    [ariaLabel]="ariaLabel ?? placeholder"
    [class.select-md]="size === 'md'"
    class="ng-select themed-select"
    notFoundText="Keine Ergebnisse">
    @if (optionTemplate) {
      <ng-template let-index="index" let-item="item" ng-option-tmp>
        <ng-container
          [ngTemplateOutletContext]="{ $implicit: item, index: index }"
          [ngTemplateOutlet]="optionTemplate">
        </ng-container>
      </ng-template>
    }
  </ng-select>
} @else {
  <!-- Assign first, then emit — see the branch above (#267). -->
  <ng-select
    (ngModelChange)="current = $event; onCurrentChange($event)"
    [ngModel]="current"
    [bindLabel]="bindLabel"
    [bindValue]="bindValue"
    [clearable]="clearable"
    [disabled]="disabled"
    [items]="options"
    [multiple]="multiple"
    [placeholder]="placeholder"
    [searchFn]="defaultSearchFn"
    [ariaLabel]="ariaLabel ?? placeholder"
    [class.select-md]="size === 'md'"
    class="ng-select themed-select"
    notFoundText="Keine Ergebnisse">
    @if (optionTemplate) {
      <ng-template let-index="index" let-item="item" ng-option-tmp>
        <ng-container
          [ngTemplateOutletContext]="{ $implicit: item, index: index }"
          [ngTemplateOutlet]="optionTemplate">
        </ng-container>
      </ng-template>
    }
  </ng-select>
}
